import { render, staticRenderFns } from "./EmployeeServices.vue?vue&type=template&id=6b38e1cc&scoped=true&"
import script from "./EmployeeServices.vue?vue&type=script&lang=js&"
export * from "./EmployeeServices.vue?vue&type=script&lang=js&"
import style0 from "./EmployeeServices.vue?vue&type=style&index=0&id=6b38e1cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b38e1cc",
  null
  
)

export default component.exports